import { Injectable } from "@angular/core";
import * as JSZip from "jszip";
import { saveAs } from 'file-saver';
@Injectable({
  providedIn: "root",
})
export class ZipService {
  createPdf(array) {
    const downloadLink = document.createElement("a");
    console.log(array);

    let fileName = array[0].jsnname + ".pdf";
    downloadLink.href = "data:application/pdf;base64," + array[0].base64file;;
    downloadLink.download = fileName;
    downloadLink.click();

  }
  createZip(zipName, array) {
    let files = array;
    var zip = new JSZip();

    for (var i = 0; i < files.length; i++) {
      let fileName = files[i].jsnname + ".pdf";
      zip.file(fileName, files[i].base64file, { base64: true });
    }
    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, `${zipName}.zip`);
    });
  }
  createGroupZip(mainName: string, array: any[]) {
    const masterZip = new JSZip();

    // Loop through each group to create individual ZIPs
    array.forEach((group) => {
      if (!group.files || !Array.isArray(group.files)) return;

      const groupZip = new JSZip();

      // Add PDFs to the group's ZIP
      group.files.forEach((file: any) => {
        const fileName = file.jsnname + '.pdf';
        groupZip.file(fileName, file.base64file, { base64: true });
      });

      // Generate group ZIP as a binary blob and add to master ZIP
      masterZip.file(
        `${group.fileName || 'group'}.zip`,
        groupZip.generateAsync({ type: 'uint8array' }) // generate as Uint8Array for nested ZIP
      );
    });

    // Wait for all nested ZIPs to finish generating
    masterZip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${mainName}.zip`);
    });
  }
  createFolderZip(mainName: string, array: any[]) {
    const masterZip = new JSZip();

    // Loop through each group to create individual ZIPs
    array.forEach((group) => {
      if (!group?.response?.files || !Array.isArray(group?.response?.files)) return;

      // Add PDFs to the group's ZIP
      group?.response?.files.forEach((file: any) => {
        const fileName = group?.payload?.departmentname.replace(/\//g, "_") + '/' + file.jsnname.replace(/\//g, "_") + '.pdf';
        // groupZip.file(fileName, file.base64file, { base64: true });
        masterZip.file(fileName, file.base64file, { base64: true });
      });
    });

    // Wait for all nested ZIPs to finish generating
    masterZip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${mainName}.zip`);
    });
  }
}
